import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import BenefitsTable from "./components/BenefitsTable";

import { benefits } from "./constants";
import styles from "./styles.module.scss";

const Benefits: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h2" color="white">
        Benefits
      </Label>
      <Label className={styles.subtitle} color="white" variant="s1">
        We’ve got you covered — from health insurance to unlimited paid time
        off, but there’s more…
      </Label>
      <BenefitsTable benefits={benefits} />
    </Content>
  );
};

export default Benefits;
